<template>
  <component
    :is="component"
    @click="handleClick"
    :class="[
      $style.root,
      {[$style.selected]: selected, [$style.disabled]: disabled},
    ]"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'Option',

  inject: ['Select'],

  props: {
    value: {type: null},

    disabled: {
      type: Boolean,
      default: false,
    },

    component: {
      type: [String, Object],
      default: 'li',
    },
  },

  methods: {
    handleClick() {
      if (!this.disabled) {
        this.Select.handleSelect(this.value);
      }
    },
  },

  computed: {
    selected() {
      if (Array.isArray(this.Select.value)) {
        return this.Select.value.includes(this.value);
      } else {
        return this.Select.value === this.value;
      }
    },
  },
};
</script>

<style module lang="scss">
.root {
  cursor: pointer;
  @apply text-secondary
    p-2;
}

.root:hover {
  @apply bg-dull-light;
}

.selected,
.selected:hover {
  @apply text-primary;
}

.disabled,
.disabled:hover {
  cursor: default;

  @apply text-dull
    bg-dull-light;
}

.learnMore {
  @apply text-blue-600;
}
</style>
